module.exports = __webpack_public_path__ + "img/gift4-01-c06-k1.8e452169.png";